"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
require("./card.css");
const button_1 = require("@nbc-design/button");
const hooks_1 = require("@nbc-design/hooks");
const AccordionClose_1 = require("@nbc-design/icons/lib/web/AccordionClose");
const AccordionOpen_1 = require("@nbc-design/icons/lib/web/AccordionOpen");
const theme_provider_1 = require("@nbc-design/theme-provider");
const tokens_json_1 = tslib_1.__importDefault(require("@nbc-design/tokens/dist/styles/tokens.json"));
/** The card is a container useful when you want a block information to stand out. */
const Card = ({ children, className, dataTest = 'card', contentClassName, header, border, borderRadius = 'medium', appearance = 'primary', showSeparator = true, collapsible, ...other }) => {
    const currentTheme = (0, theme_provider_1.useTheme)();
    const themeIsLegacy = currentTheme === 'legacy' || currentTheme === undefined || currentTheme === null;
    const borderState = border ?? 'outlineDefault';
    const normalizedAppearance = appearance === 'white'
        ? 'primary'
        : appearance === 'grey050'
            ? 'secondary'
            : appearance === 'blue025' || appearance === 'blue050'
                ? 'tertiary'
                : appearance;
    const durationMs = Number.parseInt(tokens_json_1.default['ad-long'].replace('ms', ''), 10) || 200;
    const { isCollapseOpen, isAnimated, isContentHidden, maxHeight, toggle, innerRef } = (0, hooks_1.useCollapsible)({
        defaultOpen: collapsible?.isCollapsible ? !!collapsible?.defaultOpen : true,
        durationMs: collapsible?.durationMs ?? durationMs,
        onToggleDone: collapsible?.onToggleDone,
        open: collapsible?.open,
        onOpenChange: collapsible?.onOpenChange,
    });
    const isCollapsing = isAnimated && !isCollapseOpen;
    const isExpanding = isAnimated && isCollapseOpen;
    const classes = (0, classnames_1.default)('dsc-card', themeIsLegacy &&
        borderState !== 'outlineDefault' &&
        `is-border${borderState[0].toUpperCase() + borderState.slice(1)}`, normalizedAppearance !== 'primary' && `is-${normalizedAppearance}`, themeIsLegacy && borderRadius !== 'medium' && `is-borderRadius-${borderRadius.toLowerCase()}`, collapsible?.isCollapsible && 'is-collapsible', isContentHidden && 'is-hidden', isCollapsing && 'is-collapsing', isExpanding && 'is-expanding', className);
    const headerClasses = (0, classnames_1.default)('dsc-card__header', header?.className, showSeparator && 'dsc-card__header--separator');
    const contentClasses = (0, classnames_1.default)('dsc-card__content', contentClassName);
    const contentId = React.useId();
    const titleId = React.useId();
    const ariaLabel = isCollapseOpen
        ? (collapsible?.ariaLabelClose ?? 'Close content')
        : (collapsible?.ariaLabelOpen ?? 'Expand content');
    const isControlled = collapsible?.open !== undefined;
    const handleCollapseClick = () => {
        if (isControlled) {
            collapsible?.onOpenChange?.(!collapsible.open);
        }
        else {
            toggle();
        }
    };
    const defaultTrigger = ((0, jsx_runtime_1.jsx)(button_1.IconButton, { className: "dsc-card__collapseBtn", "aria-expanded": isCollapseOpen, "aria-controls": contentId, onClick: handleCollapseClick, appearance: "minimal", size: "small", "aria-label": ariaLabel, icon: isCollapseOpen ? (0, jsx_runtime_1.jsx)(AccordionClose_1.AccordionClose, { size: "medium" }) : (0, jsx_runtime_1.jsx)(AccordionOpen_1.AccordionOpen, { size: "medium" }) }));
    const openEl = collapsible?.expandTrigger;
    const closeEl = collapsible?.collapseTrigger;
    const customTrigger = isCollapseOpen
        ? React.isValidElement(closeEl)
            ? closeEl
            : null
        : React.isValidElement(openEl)
            ? openEl
            : null;
    const collapsibleButton = customTrigger
        ? React.cloneElement(customTrigger, {
            onClick: (e) => {
                customTrigger.props.onClick?.(e);
                if (!e.defaultPrevented)
                    handleCollapseClick(e);
            },
            'aria-expanded': isCollapseOpen,
            'aria-controls': contentId,
            'aria-label': ariaLabel,
            className: (0, classnames_1.default)('dsc-card__collapseBtn', customTrigger.props.className),
        })
        : defaultTrigger;
    const headerMarkup = header && ((0, jsx_runtime_1.jsxs)("header", { className: headerClasses, children: [(0, jsx_runtime_1.jsx)("div", { className: "dsc-card__titleContainer", id: titleId, children: header.title }), (0, jsx_runtime_1.jsx)("div", { className: "dsc-card__actionsContainer", children: collapsible?.isCollapsible ? collapsibleButton : (header.actions ?? null) })] }));
    return ((0, jsx_runtime_1.jsxs)("div", { ...other, className: classes, "data-test": dataTest, children: [headerMarkup, collapsible?.isCollapsible ? ((0, jsx_runtime_1.jsx)("div", { id: contentId, className: contentClasses, role: "region", "aria-labelledby": titleId, "aria-hidden": !isCollapseOpen || undefined, hidden: isContentHidden, style: { maxHeight }, children: (0, jsx_runtime_1.jsx)("div", { ref: innerRef, children: children }) })) : ((0, jsx_runtime_1.jsx)("div", { className: contentClasses, children: children }))] }));
};
exports.Card = Card;
exports.Card.displayName = 'Card';
//# sourceMappingURL=card.js.map